(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-klubb"] && !Shopify.designMode) return;
  try {
    // Esc lukker klubb-panelet (WCAG 1.4.13: hoverbart innhold maa kunne avvises). Panelet er
  // ellers ren CSS (:hover/:focus-within), og dette er det ene, bevisste unntaket fra
  // header-chromets «ingen ny JS»-regel; a11y-reviewen 2026-08-21 pekte paa at CSS-only-rammen
  // selv var hindringen. Klassen overstyrer :hover/:focus-within til musa forlater chipen.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    for (const club of document.querySelectorAll('.skm-club')) {
      if (!club.matches(':hover, :focus-within')) continue;
      club.classList.add('skm-club--lukket');
      const trigger = club.querySelector('.skm-club__trigger');
      if (trigger instanceof HTMLElement && club.contains(document.activeElement)) trigger.focus();
    }
  });
  document.addEventListener(
    'mouseleave',
    (event) => {
      if (event.target instanceof Element && event.target.classList?.contains('skm-club')) {
        event.target.classList.remove('skm-club--lukket');
      }
    },
    true
  );
  document.addEventListener('focusout', (event) => {
    const club = event.target instanceof Element ? event.target.closest('.skm-club') : null;
    if (club && !(event.relatedTarget instanceof Node && club.contains(event.relatedTarget))) {
      club.classList.remove('skm-club--lukket');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["skm-v2-buybox"] && !Shopify.designMode) return;
  try {
    // Antall-stepper. Skopet per buybox, idempotent, re-init ved editor-load.
  (function () {
    function initQty(root) {
      if (!root || root.dataset.skmV2QtyInit === '1') return;
      var input = root.querySelector('.skm-v2-buybox__qty-input');
      var minus = root.querySelector('[data-skm-v2-qty-minus]');
      var plus = root.querySelector('[data-skm-v2-qty-plus]');
      if (!input || !minus || !plus) return;
      root.dataset.skmV2QtyInit = '1';
      function step(delta) {
        var val = parseInt(input.value, 10) || 1;
        var min = parseInt(input.min, 10) || 1;
        var max = parseInt(input.max, 10) || 99;
        input.value = Math.min(max, Math.max(min, val + delta));
      }
      minus.addEventListener('click', function () { step(-1); });
      plus.addEventListener('click', function () { step(1); });
    }
    function initAll() {
      document.querySelectorAll('[data-skm-v2-qty]').forEach(initQty);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
